module.exports = {
    signTemplate: process.env.GATSBY_SIGNATURE_TEMPLATE,
    compagnyName: process.env.GATSBY_COMPANY_NAME,
    eShopURL: process.env.GATSBY_ESHOP_URL,
    compagnyUrl: process.env.GATSBY_COMPANY_URL,
    compagnyColorPrimary: process.env.GATSBY_COMPANY_COLOR_PRIMARY,
    compagnyColorSecondary: process.env.GATSBY_COMPANY_COLOR_SECONDARY
}